export const scoreTypeToClassName = {
  level_0: "veryBad",
  level_1: "bad",
  level_2: "average",
  level_3: "good",
  level_4: "veryGood",
  level_5: "excellent",
} as const;

export const scoreTypeToTextClassName = {
  level_0: "veryBad--text",
  level_1: "bad--text",
  level_2: "average--text",
  level_3: "good--text",
  level_4: "veryGood--text",
  level_5: "excellent--text",
} as const;

export const scoreTypeToColorClassName = {
  level_0: "red",
  level_1: "red",
  level_2: "pink",
  level_3: "pink",
  level_4: "green",
  level_5: "green",
} as const;
